var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content runningQuery" },
    [
      _c("div", { staticClass: "main-content" }, [
        _c("div"),
        _c(
          "div",
          {
            staticClass: "section",
            staticStyle: { "background-color": "#fff", "margin-top": "6px" }
          },
          [
            _c(
              "el-table",
              { attrs: { data: _vm.tableData, border: "" } },
              [
                _c("el-table-column", {
                  attrs: { label: "序号", prop: "sorting", width: "50" }
                }),
                _c("el-table-column", {
                  attrs: { label: "机器人名称", prop: "taskName" }
                }),
                _c("el-table-column", {
                  attrs: { label: "计划名称", prop: "taskScheduleName" }
                }),
                _c("el-table-column", {
                  attrs: { label: "计划属性", prop: "robotAttribute" }
                }),
                _c("el-table-column", {
                  attrs: { label: "运行状态" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "span",
                            {
                              class: {
                                setColorOrange: scope.row.runningStatus === 1,
                                setColorBlue: scope.row.runningStatus === 3,
                                setColorGray: scope.row.runningStatus === 2,
                                setColorRed: scope.row.runningStatus === 4
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.runningStatus(scope.row.runningStatus)
                                )
                              )
                            ]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _c("el-table-column", {
                  attrs: { label: "创建时间", prop: "dateCreated" }
                }),
                _c("el-table-column", {
                  attrs: { label: "开始运行时间", prop: "startDateTime" }
                }),
                _c("el-table-column", {
                  attrs: { label: "结束时间", prop: "endDateTime" }
                }),
                _c("el-table-column", {
                  attrs: { label: "运行结果" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: scope.row.result === 0,
                                  expression: "scope.row.result === 0"
                                }
                              ]
                            },
                            [_vm._v("/")]
                          ),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: scope.row.result === 1,
                                  expression: "scope.row.result === 1"
                                }
                              ],
                              staticStyle: {
                                color: "#1F75D5",
                                "text-decoration": "underline"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.download(scope.row)
                                }
                              }
                            },
                            [_vm._v("下载")]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    scope.row.result === 2 ||
                                    scope.row.result === 3,
                                  expression:
                                    "scope.row.result === 2 || scope.row.result === 3"
                                }
                              ],
                              staticStyle: { color: "red" }
                            },
                            [_vm._v("失败")]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: scope.row.result === 4,
                                  expression: "scope.row.result === 4"
                                }
                              ]
                            },
                            [_vm._v("排队中")]
                          )
                        ]
                      }
                    }
                  ])
                }),
                _c("el-table-column", {
                  attrs: { fixed: "right", label: "操作", width: "300" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "text", size: "small" },
                              on: {
                                click: function($event) {
                                  return _vm.toView(scope.row)
                                }
                              }
                            },
                            [_vm._v("查看日志")]
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.toViewShow,
            title: "查看日志",
            width: "580px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.toViewShow = $event
            }
          }
        },
        [
          _c("div", { staticClass: "dialog-content" }, [
            _c("span", { staticClass: "detailed-information" }, [
              _vm._v("详细信息")
            ]),
            _c("div", { staticClass: "mr-top" }, [
              _c("span", [_vm._v("机器人名称：")]),
              _c("span", { staticClass: "setColorGray" }, [
                _vm._v(_vm._s(_vm.logForm.taskName))
              ])
            ]),
            _c("div", { staticClass: "information mr-top" }, [
              _c("div", [
                _c("span", [_vm._v("运行结果：")]),
                _c(
                  "span",
                  {
                    staticClass: "setColorBlue",
                    class: {
                      setColorRed:
                        _vm.logForm.result === 2 || _vm.logForm.result === 3
                    }
                  },
                  [_vm._v(_vm._s(_vm.resultData(_vm.logForm.result)))]
                )
              ]),
              _c("div", [
                _c("span", [_vm._v("运行方式：")]),
                _c("span", { staticClass: "setColorGray" }, [
                  _vm._v(
                    _vm._s(
                      _vm.logForm.taskRunningPlan === 9
                        ? "立即运行"
                        : _vm.logForm.taskRunningPlan === 1
                        ? "计划运行"
                        : ""
                    )
                  )
                ])
              ]),
              _c("div", [
                _c("span", [_vm._v("运行时长：")]),
                _c("span", { staticClass: "setColorGray" }, [
                  _vm._v(_vm._s(_vm.conversionTime(_vm.logForm.duration)))
                ])
              ])
            ]),
            _c("div", { staticClass: "mr-top" }, [
              _c("span", [_vm._v("开始时间：")]),
              _c("span", { staticClass: "setColorGray" }, [
                _vm._v(_vm._s(_vm.logForm.startDateTime))
              ])
            ]),
            _c("span", { staticClass: "detailed-information mr-top" }, [
              _vm._v("运行日志")
            ]),
            _c("div", { staticClass: "log-contents mr-top" }, [
              _vm._v(_vm._s(_vm.logForm.traceLog))
            ])
          ]),
          _c(
            "div",
            {
              staticStyle: { "padding-right": "5px" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.confirm } },
                [_vm._v("确认")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }